// src\themes\lino\elements\comment\CommnetList.tsx
'use client';

import { useDictionary } from '@/core/hooks/use-dictionary';
import { CommentItem as CommentType } from '@/core/types/comments';

import CommentItem from './CommnetItem';

interface CommentListProps {
  comments: CommentType[];
}

export default function CommentList({ comments }: CommentListProps) {
  const { dictionary } = useDictionary();

  if (!comments?.length) return null;

  return (
    <div className="w-full">
      <span className="block mb-6 text-[11px] uppercase tracking-[0.14em] text-primary-500 pb-4 border-b border-primary-900">
        {dictionary.nav?.comments}
      </span>
      <ul className="flex flex-col gap-2">
        {comments.map(comment => (
          <CommentItem key={comment.id} comment={comment} />
        ))}
      </ul>
    </div>
  );
}